export const fr = {
  title: `Sexualité`,
  p1: `Avec une épilepsie bien maîtrisée, une vie sexuelle satisfaisante peut certainement être accomplie.`,
  p2: `Toutefois, l’épilepsie est souvent accompagnée d’une diminution de libido (désir sexuel). De plus, la dysfonction érectile est un autre problème fréquemment rencontré chez les hommes atteints d’épilepsie.  D’autant plus, il est important de considérer les effets secondaires des médicaments traitant l’épilepsie, dont: dysfonction érectile, moins d’excitation et de désir sexuel. Certains médicaments peuvent poser plus de risques que d’autres.`,
  p3: `Est-ce que les relations sexuelles peuvent être un élément déclencheur pour une crise d’épilepsie?`,
  p4: `Très rarement. En effet, cela peut arriver à l’occasion, mais n’est pas un agent de crise principal.`,
  tips: {
    title: `Conseils:`,
    bullets: [
      `Avoir un partenaire compréhensif face à la maladie`,
      `Valoriser une bonne adhérence aux médicaments`,
      `Écouter son corps et ses besoins`,
      `Assurer une bonne communication dans le couple`,
      `Consulter un sexologue, au besoin.`
    ]
  }
};
